module.exports = __webpack_public_path__ + "img/gis4_on.28653bdf.png";